export default __webpack_public_path__ + "static/media/up.4d2d1070.svg";